import React from "react";
import { sessionService } from "redux-react-session";
import moment from "moment";
import { getSubscription } from "../services/careBalanceService";
import careBalanceService, { isPatientGatewayEnabled } from "../services/careBalanceService";
import userService from "../services/userService";
import LoadingScreen from "../components/LoadingScreen";
import { getAccountsDashboardUrl } from "../services/utilityService";
import { Link } from "react-router-dom";
import CountdownTimer from "./CountdownTimer";
import PageBodyHeader from "./boxes/PageBodyHeader";
import { shouldRouteExpiredPlanUsers } from "./care-balance/utils/should-route-to-expiry-page";
import { withTranslation } from "react-i18next";
import { envVariables } from "../config/appConfig";

class PlanExpiredPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      error: {},
    };
  }

  componentDidMount() {
    sessionService.loadUser().catch(() => ({})).then((user) => {
      getSubscription()
        .then((plan) => {
          user.plan = plan.product.name;
          user.planType = plan.product.plan_type;
          user.planInfo = plan;
          sessionService.saveUser(user).then(() => {
            this.setState({ user });

            //check if plan has been renewed (i.e., now valid)...and go back to app
            if (!shouldRouteExpiredPlanUsers(user)) {
              // also verify profile is still active before redirecting back
              const getProfile = isPatientGatewayEnabled()
                ? careBalanceService.getProfile()
                : userService.getProfile();
              getProfile
                .then(() => {
                  window.location = "/";
                })
                .catch(() => {
                  // profile inactive — stay on this page
                });
            }
          });
        })
        .catch(() => {
          // subscription fetch failed — stay on this page
          this.setState({ user });
        });
    });
  }

  goToAccounts = () => {
    const refCode = this.state.user.planInfo.invoice_reference_code;
    window.location = `${getAccountsDashboardUrl()}/dashboard/invoices/${refCode}`;
  };

  renderLoading = () => {
    return <LoadingScreen />;
  };

  render() {
    const { user, error } = this.state;
    const { t } = this.props;

    if (!user.firstName && !user.planInfo) return this.renderLoading();
    if (!user.planInfo) return (
      <div className="container expired-plan-container">
        <PageBodyHeader />
        <div className="content">
          <div className="content-main">
            <div style={{ alignSelf: "center", margin: "5px auto" }} className="dashboard-card dashboard-card--pb-large">
              <div className="expiry-notice-wrapper">
                <div className="dashboard-card__alert dashboard-card__alert--blue dashboard-card__body-text">
                  <p className="article__text article__text--bold">{t("planExpiredTitle")}</p>
                </div>
                <p className="dashboard-card__body-text">{t("planDeactivationReason")}</p>
                <a href="/logout" className="dashboard__secondary-btn">{t("logout", { ns: "common" })}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    const countDown = moment(user.planInfo.cover_start_date)
      .add(7, "d")
      .format();

    return (
      <div className="container expired-plan-container">
        <PageBodyHeader />
        <div className="content">
          <div className="content-image">
            {error.message && (
              <div
                ref={(el) => (this.errorHolder = el)}
                style={{
                  padding: "10px",
                  margin: "10px",
                  backgroundColor: "red",
                  color: "white",
                  visibility: error.message ? "visible" : "hidden",
                }}
              >
                <h3>{error.message}</h3>
              </div>
            )}
          </div>
          <div className="content-main">
            {user.planInfo.active_status_id === 7 ? (
              <div>
                <h1 className="plan-expiry-notice__header-text">
                  {t("headerText")}
                </h1>
                <p className="plan-expiry-notice__body-text">
                  {t("resubscriptionMessage")}
                </p>
                <p className="plan-expiry-notice__body-text">
                  {t("waitToAccessCareMessage")}
                </p>
                <p className="plan-expiry-notice__body-text">
                  {t("dashboardAvailabilityInstruction")}
                </p>
                <p className="plan-expiry-notice__body-text">
                  {t("howToGetHelp", {
                    contactPhoneNumber: envVariables.CONTACT_PHONE_NUMBER,
                    contactEmail: envVariables.CONTACT_EMAIL,
                  })}
                </p>
                <CountdownTimer date={countDown} />
              </div>
            ) : (
              <div
                style={{ alignSelf: "center", margin: "5px auto" }}
                className="dashboard-card dashboard-card--pb-large"
              >
                <div className="expiry-notice-wrapper">
                  <div className="dashboard-card__alert dashboard-card__alert--blue dashboard-card__body-text">
                    <p className="article__text article__text--bold">
                      {t("planExpiredTitle")}
                    </p>
                  </div>
                  <p className="dashboard-card__body-text">
                    {t("planDeactivationReason")}
                  </p>
                  {user.planInfo.is_owner ? (
                    <>
                      <p className="dashboard-card__body-text">
                        {t("reactivatePlanQuestion")}
                      </p>
                      <button
                        className="dashboard__primary-btn"
                        onClick={this.goToAccounts}
                      >
                        <p>{t("reactivePlanButtonText")}</p>
                      </button>
                    </>
                  ) : (
                    <>
                      <p className="dashboard-card__body-text">
                        {t("dependentPlanExpireMessage")}
                      </p>
                    </>
                  )}
                  <a href="/logout" className="dashboard__secondary-btn">
                    {t("logout", { ns: "common" })}
                  </a>
                </div>
              </div>
            )}

            <p>
              {t("referralAccess")}{" "}
              <Link to="/refer">{t("here", { ns: "common" })}</Link>
            </p>

            <p>
              {t("contactSupport")}{" "}
              <a
                href={`mailto: ${envVariables.CONTACT_EMAIL}?subject=${t(
                  "contactEmailSubject",
                )}`}
              >
                {" "}
                {envVariables.CONTACT_EMAIL}
              </a>
              {t("orCall")}{" "}
              <a href={`tel:${envVariables.CONTACT_PHONE_NUMBER}`}>
                {envVariables.CONTACT_PHONE_NUMBER}
              </a>{" "}
              {t("forEnquiries")} <br />
              {t("apologiesText")}
            </p>
            <p>
              {t("click", { ns: "common" })}{" "}
              <a href="/logout">{t("hereToLogout")}</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("planExpired")(PlanExpiredPage);
